import {C2CMoneyTransactionRestService} from './restServices';
import storageService from '../storageService';

var service = {};

service.getC2cMoneyTransactionEventById = async (
  c2cMoneyTransactionEventId,
  token,
) => {
  const requestObject = {
    endpoint: c2cMoneyTransactionEventId,
    c2cMoneyTransactionEventId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await C2CMoneyTransactionRestService.get(
    requestObject,
    requestObject,
  );
  return response.data;
};
service.updateC2cMoneyTransactionEvent = async (
  mentorId,
  newStripeConnectedAccountId,
  token,
) => {
  let requestObj = {
    mentorId,
    newStripeConnectedAccountId,
    token: token ? token : storageService.getItem('token'),
  };
  const response = await C2CMoneyTransactionRestService.update(
    {
      endpoint: 'update-mentor-account',
    },
    requestObj,
  );
  return response.data;
};

const c2CMoneyTransactionRestService = {...service};

export default c2CMoneyTransactionRestService;
